import { Component, OnInit } from '@angular/core';

import { ConfigService } from 'src/app/core/services/theme-config.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
  version: string;

  constructor(public themeConfig: ConfigService) {}

  ngOnInit() {
    this.version = environment.version;
  }
}
